// loginSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from '../slices/baseUrl';

// Define the initial state for the login slice
const initialState = {
    user: null,
    allRoles: [],
    userAccess: [],
    loginStatus: false,
    status: 'idle',
    error: null
};

// Sign up
// export const signUp = createAsyncThunk('user/signUp', async loginData => {
//     try {
//         const response = await axios.post(
//             `${baseUrl}/users/advertiserSignup`,
//             loginData
//         );
//         return response.data;
//     } catch (error) {
//         if (error?.response?.data) {
//             throw Error(error?.response?.data);
//         } else {
//             throw Error(error?.response?.data);
//         }
//     }
// });

export const signUp = createAsyncThunk('user/signUp', async loginData => {
    fetch(`${baseUrl}/users/advertiserSignup`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
    })
        .then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error(response.status);
            }
        })
        .then(json => {
            return json;
        })

        .catch(err => {
            return err;
        });
});

export const userLogin = createAsyncThunk('user/userLogin', async (loginData, { rejectWithValue }) => {
    try {
        const response = await axios.post(
            `${baseUrl}/users/login/admin`,
            loginData
        );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
    }
});

export const loginStatus = createAsyncThunk(
    'loginStatus',
    async loginStatus => {
        try {
            if (loginStatus) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            throw Error(error?.response?.data?.message || 'Error logging in');
        }
    }
);

// Create an async thunk for fetching users data
export const getUserData = createAsyncThunk(
    'users/getUserData',
    async email => {
        const response = await axios(`${baseUrl}/ads/getDataByEmail/${email}
`);
        return response.data;
    }
);

export const logout = createAsyncThunk('user/logout', async () => {
    return false;
});

export const getAllRoles = createAsyncThunk(
    'users/getAllRoles',
    async email => {
        const response = await axios(`${baseUrl}/access/getAllRoles`);
        return response.data;
    }
);

export const getUserAccess = createAsyncThunk(
    'users/getUserAccess',
    async role => {
        // alert(role);
        try {
            const response = await axios(`${baseUrl}/access/getAccess/${role}`);
            return response.data;
        } catch (error) {
            throw Error(
                error?.response?.data?.message || 'Error getting user access'
            );
        }
    }
);

// Create a login slice
const loginSlice = createSlice({
    name: 'login',
    initialState,

    reducers: {
        // Define any additional synchronous actions here if needed
    },
    extraReducers: builder => {
        builder
            .addCase(signUp.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(signUp.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
                state.error = null;
            })
            .addCase(signUp.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(userLogin.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(userLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
                state.error = null;
            })
            .addCase(userLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(logout.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(logout.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
                state.loginStatus = false;
                state.error = null;
            })
            .addCase(logout.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
        builder
            .addCase(loginStatus.pending, state => {
                state.status = 'loading';
            })
            .addCase(loginStatus.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.loginStatus = action.payload;
            })
            .addCase(loginStatus.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(getUserData.pending, state => {
                state.status = 'loading';
            })
            .addCase(getUserData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.userData = action.payload;
            })
            .addCase(getUserData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(getAllRoles.pending, state => {
                state.status = 'loading';
            })
            .addCase(getAllRoles.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.allRoles = action.payload;
            })
            .addCase(getAllRoles.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
        builder
            .addCase(getUserAccess.pending, state => {
                state.status = 'loading';
            })
            .addCase(getUserAccess.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.userAccess = action.payload;
            })
            .addCase(getUserAccess.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

// Export the async thunk for use in components

// Export the reducer
export default loginSlice.reducer;
